import { Loader, Modal, ModalWidth, ToasterMode, useGlobalModalContext } from '@creditsights/styleguide-web';
import React, { useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { toasterState } from '../../../atoms/toaster.atom';
import { GENERIC_ERROR_TEXT } from '../../../Constants';
import { fetchBondCompareExport } from '../../../services/bond-compare.service';
import styles from './ExportBondCompareModal.module.scss';

const ExportBondComparisonsModal = (): React.ReactElement => {
  const { closeModal, store } = useGlobalModalContext();
  const [loading, setLoading] = useState(false);
  const showToaster = useSetRecoilState(toasterState);

  const handleDownloadClick = (type: 'text' | 'text-with-diff') => async () => {
    setLoading(true);
    try {
      const { data, fileName } = await fetchBondCompareExport(type, store.props.ids);
      const blob = new Blob([data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      closeModal();
    } catch (e) {
      showToaster({
        text: GENERIC_ERROR_TEXT,
        mode: ToasterMode.ERROR,
      });
      throw e;
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal width={ModalWidth.Medium} open onClose={closeModal} headerTitle="Export Side-by-side Comparisons to Excel">
      <div className={styles.wrapper}>
        {loading ? (
          <div className={styles.loader}>
            <Loader />
          </div>
        ) : null}
        <h4>Export As:</h4>
        <p>
          <span className={styles.link} onClick={handleDownloadClick('text')}>
            Text Only
          </span>{' '}
          OR{' '}
          <span className={styles.link} onClick={handleDownloadClick('text-with-diff')}>
            Text With Differences
          </span>
        </p>
      </div>
    </Modal>
  );
};

export default ExportBondComparisonsModal;
